
(function () {
  var KINDS = {
    tower: { label: 'Tower', w: 6.4, ar: 0.42 },
    house: { label: 'House', w: 7.6, ar: 0.78 },
    arch: { label: 'Arch', w: 11, ar: 1.83 },
    column: { label: 'Column', w: 3.2, ar: 0.31 },
    fir: { label: 'Fir tree', w: 4.4, ar: 0.45 },
    leafy: { label: 'Leafy tree', w: 4.6, ar: 0.45 },
    rainbow: { label: 'Rainbow', w: 13, ar: 1.82 },
    teapot: { label: 'Teapot', w: 6.4, ar: 1.21 }
  };
  var SVG = {"tower": "<svg viewBox=\"0 0 60 142\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M30 4 C31.6 4 32.5 5 33.1 6.4 L54.2 51.6 C55.3 54.2 53.8 56 51.2 56 L8.8 56 C6.2 56 4.7 54.2 5.8 51.6 L26.9 6.4 C27.5 5 28.4 4 30 4 Z\" fill=\"#A9473B\"></path><path d=\"M31 6 L54.2 51.6 C55.3 54.2 53.8 56 51.2 56 L37 56 Z\" fill=\"#000000\" opacity=\"0.13\"></path><circle cx=\"30\" cy=\"5\" r=\"3.4\" fill=\"#E4B45A\"></circle><rect x=\"10\" y=\"56\" width=\"40\" height=\"80\" rx=\"2\" fill=\"#EDB487\"></rect><rect x=\"38\" y=\"56\" width=\"12\" height=\"80\" fill=\"#000000\" opacity=\"0.08\"></rect><rect x=\"10\" y=\"56\" width=\"40\" height=\"4\" fill=\"#000000\" opacity=\"0.1\"></rect><circle cx=\"30\" cy=\"79\" r=\"11\" fill=\"#FFD36E\" class=\"halo\"></circle><circle cx=\"30\" cy=\"101\" r=\"11\" fill=\"#FFD36E\" class=\"halo\"></circle><path d=\"M24 86 V76 A6 6 0 0 1 36 76 V86 Z\" class=\"win\"></path><path d=\"M24 108 V98 A6 6 0 0 1 36 98 V108 Z\" class=\"win\"></path><path d=\"M23 136 V124 A7 7 0 0 1 37 124 V136 Z\" fill=\"#8E5236\"></path><rect x=\"8\" y=\"134\" width=\"44\" height=\"4\" rx=\"2\" fill=\"#000000\" opacity=\"0.1\"></rect></svg>", "house": "<svg viewBox=\"0 0 70 90\" aria-hidden=\"true\" focusable=\"false\"><rect x=\"9\" y=\"34\" width=\"52\" height=\"54\" rx=\"2\" fill=\"#EBC596\"></rect><rect x=\"45\" y=\"34\" width=\"16\" height=\"54\" fill=\"#000000\" opacity=\"0.07\"></rect><path d=\"M4 36 L35 7 L66 36 Z\" fill=\"#C2643E\" stroke=\"#C2643E\" stroke-width=\"3\" stroke-linejoin=\"round\"></path><path d=\"M35 7 L66 36 L35 36 Z\" fill=\"#000000\" opacity=\"0.1\"></path><circle cx=\"23\" cy=\"52\" r=\"10\" fill=\"#FFD36E\" class=\"halo\"></circle><circle cx=\"47\" cy=\"52\" r=\"10\" fill=\"#FFD36E\" class=\"halo\"></circle><rect x=\"17\" y=\"46\" width=\"12\" height=\"12\" rx=\"1.5\" class=\"win\"></rect><rect x=\"41\" y=\"46\" width=\"12\" height=\"12\" rx=\"1.5\" class=\"win\"></rect><path d=\"M23 46 V58 M17 52 H29 M47 46 V58 M41 52 H53\" stroke=\"#EBC596\" stroke-width=\"1.2\"></path><path d=\"M29 88 V71 A6 6 0 0 1 41 71 V88 Z\" fill=\"#7E4A33\"></path></svg>", "arch": "<svg viewBox=\"0 0 110 60\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M3 6 H107 V58 H78 V36 A23 23 0 0 0 32 36 V58 H3 Z\" fill=\"#EAD7B4\"></path><rect x=\"3\" y=\"6\" width=\"104\" height=\"5\" fill=\"#FFFFFF\" opacity=\"0.3\"></rect><rect x=\"92\" y=\"6\" width=\"15\" height=\"52\" fill=\"#000000\" opacity=\"0.07\"></rect><path d=\"M78 58 V36 A23 23 0 0 0 32 36 V58\" fill=\"none\" stroke=\"#000000\" stroke-opacity=\"0.12\" stroke-width=\"3\"></path></svg>", "column": "<svg viewBox=\"0 0 34 110\" aria-hidden=\"true\" focusable=\"false\"><rect x=\"1\" y=\"3\" width=\"32\" height=\"9\" rx=\"1.5\" fill=\"#F2E7D0\"></rect><rect x=\"4\" y=\"12\" width=\"26\" height=\"4\" fill=\"#E2D2B2\"></rect><rect x=\"7\" y=\"16\" width=\"20\" height=\"80\" fill=\"#F0E3C8\"></rect><rect x=\"21\" y=\"16\" width=\"6\" height=\"80\" fill=\"#000000\" opacity=\"0.07\"></rect><path d=\"M12 18 V94 M17 18 V94 M22 18 V94\" stroke=\"#000000\" stroke-opacity=\"0.08\" stroke-width=\"1\"></path><rect x=\"4\" y=\"96\" width=\"26\" height=\"5\" fill=\"#E2D2B2\"></rect><rect x=\"1\" y=\"101\" width=\"32\" height=\"7\" rx=\"1.5\" fill=\"#F2E7D0\"></rect></svg>", "fir": "<svg viewBox=\"0 0 50 110\" aria-hidden=\"true\" focusable=\"false\"><rect x=\"21\" y=\"80\" width=\"8\" height=\"16\" fill=\"#D9C29A\"></rect><path d=\"M9 98 Q9 94 25 94 Q41 94 41 98 V102 Q41 106 25 106 Q9 106 9 102 Z\" fill=\"#DCC59E\"></path><path d=\"M25 30 L46 78 Q47 82 43 82 H7 Q3 82 4 78 Z\" fill=\"#6D7E4A\"></path><path d=\"M25 16 L41 54 Q42 57 39 57 H11 Q8 57 9 54 Z\" fill=\"#7C8E56\"></path><path d=\"M25 3 L36 30 Q37 33 34 33 H16 Q13 33 14 30 Z\" fill=\"#8C9D63\"></path><path d=\"M25 3 L36 30 Q37 33 34 33 H25 Z M25 16 L41 54 Q42 57 39 57 H25 Z M25 30 L46 78 Q47 82 43 82 H25 Z\" fill=\"#000000\" opacity=\"0.1\"></path></svg>", "leafy": "<svg viewBox=\"0 0 50 110\" aria-hidden=\"true\" focusable=\"false\"><rect x=\"22.5\" y=\"44\" width=\"5\" height=\"54\" fill=\"#D9C29A\"></rect><path d=\"M9 98 Q9 94 25 94 Q41 94 41 98 V102 Q41 106 25 106 Q9 106 9 102 Z\" fill=\"#DCC59E\"></path><circle cx=\"25\" cy=\"27\" r=\"22\" fill=\"#B4A64F\"></circle><path d=\"M25 5 A22 22 0 0 1 25 49 A15 22 0 0 0 25 5 Z\" fill=\"#000000\" opacity=\"0.1\"></path><ellipse cx=\"17\" cy=\"20\" rx=\"4\" ry=\"2\" transform=\"rotate(-30 17 20)\" fill=\"#8E8A3B\" opacity=\"0.55\"></ellipse><ellipse cx=\"29\" cy=\"15\" rx=\"4\" ry=\"2\" transform=\"rotate(20 29 15)\" fill=\"#8E8A3B\" opacity=\"0.55\"></ellipse><ellipse cx=\"22\" cy=\"33\" rx=\"4\" ry=\"2\" transform=\"rotate(35 22 33)\" fill=\"#8E8A3B\" opacity=\"0.55\"></ellipse><ellipse cx=\"34\" cy=\"30\" rx=\"4\" ry=\"2\" transform=\"rotate(-25 34 30)\" fill=\"#8E8A3B\" opacity=\"0.55\"></ellipse></svg>", "rainbow": "<svg viewBox=\"0 0 120 66\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M8 64 A52 52 0 0 1 112 64\" fill=\"none\" stroke=\"#A8B985\" stroke-width=\"12\"></path><path d=\"M20 64 A40 40 0 0 1 100 64\" fill=\"none\" stroke=\"#E5A89B\" stroke-width=\"12\"></path><path d=\"M32 64 A28 28 0 0 1 88 64\" fill=\"none\" stroke=\"#EBCB7B\" stroke-width=\"12\"></path><path d=\"M44 64 A16 16 0 0 1 76 64\" fill=\"none\" stroke=\"#E8957A\" stroke-width=\"12\"></path><path d=\"M60 12 A52 52 0 0 1 112 64 L100 64 A40 40 0 0 0 60 24 Z\" fill=\"#000000\" opacity=\"0.06\"></path></svg>", "teapot": "<svg viewBox=\"0 0 80 66\" aria-hidden=\"true\" focusable=\"false\"><ellipse cx=\"38\" cy=\"62\" rx=\"17\" ry=\"3\" fill=\"#000000\" opacity=\"0.08\"></ellipse><path d=\"M58 38 C66 36 70 30 74 24 C75 22.6 77.4 23.6 76.4 25.6 C73 34 68 44 60 48 Z\" fill=\"#E7C49F\"></path><path d=\"M15 30 C3 30 3 51 15 51\" fill=\"none\" stroke=\"#E07A5F\" stroke-width=\"5\" stroke-linecap=\"round\"></path><ellipse cx=\"38\" cy=\"40\" rx=\"25\" ry=\"22\" fill=\"#F2D9BA\"></ellipse><path d=\"M38 18 A25 22 0 0 1 38 62 A18 22 0 0 0 38 18 Z\" fill=\"#000000\" opacity=\"0.07\"></path><ellipse cx=\"38\" cy=\"19\" rx=\"15\" ry=\"4.5\" fill=\"#E8B14E\"></ellipse><circle cx=\"38\" cy=\"13\" r=\"4.5\" fill=\"#E07A5F\"></circle><circle cx=\"33\" cy=\"42\" r=\"3.2\" fill=\"#E07A5F\"></circle><circle cx=\"43\" cy=\"42\" r=\"3.2\" fill=\"#E07A5F\"></circle><circle cx=\"38\" cy=\"37\" r=\"3.2\" fill=\"#E07A5F\"></circle><circle cx=\"38\" cy=\"47\" r=\"3.2\" fill=\"#E07A5F\"></circle><circle cx=\"38\" cy=\"42\" r=\"2.8\" fill=\"#F4C542\"></circle><ellipse cx=\"27\" cy=\"50\" rx=\"4\" ry=\"1.8\" transform=\"rotate(-25 27 50)\" fill=\"#8EA06A\"></ellipse><ellipse cx=\"49\" cy=\"50\" rx=\"4\" ry=\"1.8\" transform=\"rotate(25 49 50)\" fill=\"#8EA06A\"></ellipse></svg>"};
  var START = [
    ['fir', 18, 48], ['tower', 26, 44], ['house', 33.5, 47], ['tower', 42.5, 46], ['rainbow', 56, 47], ['fir', 72, 45], ['leafy', 78, 48], ['fir', 86, 44],
    ['leafy', 11, 28], ['column', 30, 27], ['arch', 33.6, 27], ['column', 44.8, 27], ['house', 55, 25], ['tower', 66, 26], ['fir', 82, 27],
    ['fir', 22, 9], ['teapot', 44, 8], ['leafy', 62, 10], ['house', 74, 7]
  ];

  var section = document.getElementById('play');
  var tray = document.getElementById('tray');
  var mat = document.getElementById('mat');
  var layer = document.getElementById('pieces');
  var pop = document.getElementById('popCount');
  var nightBtn = document.getElementById('nightBtn');
  if (!section || !tray || !mat || !layer) return;

  var pieces = [];
  var seq = 1000;
  var drag = null;
  var nodes = new Map();

  function startTown() {
    return START.map(function (p, i) { return { id: i + 1, k: p[0], x: p[1], b: p[2] }; });
  }
  function clampPos(k, x, b) {
    var w = KINDS[k].w;
    return {
      x: Math.round(Math.max(-1, Math.min(101 - w, x)) * 100) / 100,
      b: Math.round(Math.max(0, Math.min(70, b)) * 100) / 100
    };
  }
  function find(id) {
    for (var i = 0; i < pieces.length; i++) if (pieces[i].id === id) return pieces[i];
    return null;
  }
  function place(p) {
    var n = nodes.get(p.id);
    if (!n) return;
    n.style.left = p.x + '%';
    n.style.bottom = p.b + '%';
    n.style.zIndex = n.classList.contains('lifted') ? 3000 : Math.round(2000 - p.b * 10);
  }
  function makeNode(p) {
    var k = KINDS[p.k];
    var n = document.createElement('button');
    n.type = 'button';
    n.className = 'pc';
    n.setAttribute('aria-label', k.label + '. Drag to move it, or use the arrow keys. Delete takes it off the floor.');
    n.style.width = k.w + '%';
    n.style.aspectRatio = String(k.ar);
    n.innerHTML = SVG[p.k];
    n.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      try { n.setPointerCapture(e.pointerId); } catch (err) {}
      try { n.focus({ preventScroll: true }); } catch (err) {}
      var q = find(p.id);
      if (!q) return;
      drag = { id: p.id, sx: e.clientX, sy: e.clientY, x0: q.x, b0: q.b, rect: mat.getBoundingClientRect() };
      n.classList.remove('pc-drop');
      n.classList.add('lifted');
      place(q);
    });
    n.addEventListener('pointermove', function (e) {
      if (!drag || drag.id !== p.id) return;
      var q = find(p.id);
      if (!q) return;
      var pos = clampPos(q.k,
        drag.x0 + (e.clientX - drag.sx) / drag.rect.width * 100,
        drag.b0 - (e.clientY - drag.sy) / drag.rect.height * 100);
      q.x = pos.x;
      q.b = pos.b;
      place(q);
    });
    function end() {
      if (drag && drag.id === p.id) {
        drag = null;
        n.classList.remove('lifted');
        var q = find(p.id);
        if (q) place(q);
      }
    }
    n.addEventListener('pointerup', end);
    n.addEventListener('pointercancel', end);
    n.addEventListener('lostpointercapture', end);
    n.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 5 : 1.5;
      var dx = 0, db = 0;
      if (e.key === 'ArrowLeft') dx = -step;
      else if (e.key === 'ArrowRight') dx = step;
      else if (e.key === 'ArrowUp') db = step;
      else if (e.key === 'ArrowDown') db = -step;
      else if (e.key === 'Delete' || e.key === 'Backspace') {
        e.preventDefault();
        pieces = pieces.filter(function (q) { return q.id !== p.id; });
        sync();
        return;
      } else return;
      e.preventDefault();
      var q = find(p.id);
      if (!q) return;
      var pos = clampPos(q.k, q.x + dx, q.b + db);
      q.x = pos.x;
      q.b = pos.b;
      place(q);
    });
    n.addEventListener('animationend', function () { n.classList.remove('pc-drop'); });
    return n;
  }
  function sync() {
    var ids = new Set(pieces.map(function (p) { return p.id; }));
    nodes.forEach(function (n, id) {
      if (!ids.has(id)) { n.remove(); nodes.delete(id); }
    });
    pieces.forEach(function (p) {
      if (!nodes.has(p.id)) {
        var n = makeNode(p);
        nodes.set(p.id, n);
        layer.appendChild(n);
      }
      place(p);
    });
    if (pop) pop.textContent = pieces.length;
  }
  function add(k) {
    seq += 1;
    var pos = clampPos(k, 8 + Math.random() * 76, 4 + Math.random() * 34);
    var p = { id: seq, k: k, x: pos.x, b: pos.b };
    pieces.push(p);
    sync();
    var n = nodes.get(p.id);
    if (n) n.classList.add('pc-drop');
  }

  Object.keys(KINDS).forEach(function (k) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tray-btn';
    b.setAttribute('aria-label', 'Add a ' + KINDS[k].label.toLowerCase() + ' to the floor');
    var w = Math.round(Math.min(58, 58 * KINDS[k].ar));
    b.innerHTML = '<span class="tray-ico"><span style="width:' + w + 'px">' + SVG[k] + '</span></span><span class="tray-lbl">' + KINDS[k].label + '</span>';
    b.addEventListener('click', function () { add(k); });
    tray.appendChild(b);
  });

  nightBtn.addEventListener('click', function () {
    var on = section.classList.toggle('is-night');
    nightBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    nightBtn.textContent = on ? 'Good morning' : 'Turn out the lights';
  });
  document.getElementById('sweepBtn').addEventListener('click', function () { pieces = []; sync(); });
  document.getElementById('rebuildBtn').addEventListener('click', function () { pieces = startTown(); sync(); });

  pieces = startTown();
  sync();
})();
